import React from 'react';
import ErrorBoundary from "./Utility/ErrorBoundary";
//import ContentLeft from "./Content/ContentLeft";
//import ContentRight from "./Content/ContentRight";
import ContentMain from "./Content/ContentMain";
//import { useLocation } from 'react-router-dom'

const Content = () => {
	//const location = useLocation();
	return (
		<ErrorBoundary>
		<div id="content" className="site-content">
			{/*!location.pathname.includes("/gold") && <ContentLeft />*/}
			<ContentMain />
			{/*!location.pathname.includes("/gold") && <ContentRight />*/}
		</div>
		</ErrorBoundary>
	)
}
export default Content